import { render, staticRenderFns } from "./QuestionAoSmithPairingCode.vue?vue&type=template&id=ff8f46ae&"
import script from "./QuestionAoSmithPairingCode.vue?vue&type=script&lang=js&"
export * from "./QuestionAoSmithPairingCode.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAoSmithPairingCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports